module.exports = __webpack_public_path__ + "static/mdevcamp-5edd561ca6ad9ea4c0532898e791d752.svg";